import { lazy } from 'react';

/** Открывает список блогов */
export const BlogsPageAsync = lazy(() => import('./Blogs/BlogsPage'));
